"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
var chance_1 = require("chance");
var tournamentState_1 = require("../../interfaces/tournamentState");
var leaderboard_1 = require("./leaderboard");
var tournamentState_2 = require("./tournamentState");
var frameworks_1 = require("./frameworks");
var questions_1 = require("./questions");
var chance = new chance_1.Chance();
var emptyState = {
    tournamentStatus: tournamentState_1.TournamentStatus.PENDING,
    inProgressTournamentStatus: null,
    roundData: null,
    questionData: null,
    answerData: null,
    leaderboard: null,
    submittedAnswers: null,
    roundAnswers: null,
    userAnswersInfo: null,
    success: true,
};
var pendingState = __assign(__assign({}, emptyState), { tournamentStatus: tournamentState_1.TournamentStatus.PENDING });
var openedState = __assign(__assign({}, emptyState), { tournamentStatus: tournamentState_1.TournamentStatus.OPENED });
var getFirstRoundScheduledState = function (now) { return (__assign(__assign({}, emptyState), { tournamentStatus: tournamentState_1.TournamentStatus.IN_PROGRESS, inProgressTournamentStatus: tournamentState_1.InProgressTournamentStatus.NEXT_ROUND_SCHEDULED, roundData: (0, tournamentState_2.getRoundData)(now, true), leaderboard: { users: [], total: 0 } })); };
var getNextRoundScheduledState = function (now, numUsers) { return (__assign(__assign({}, emptyState), { tournamentStatus: tournamentState_1.TournamentStatus.IN_PROGRESS, inProgressTournamentStatus: tournamentState_1.InProgressTournamentStatus.NEXT_ROUND_SCHEDULED, roundData: (0, tournamentState_2.getRoundData)(now, false), leaderboard: (0, leaderboard_1.getLeaderboardPage)(numUsers, 0, false) })); };
var getInBetweenRoundsState = function (now, numUsers, isFirstRound) { return (__assign(__assign({}, emptyState), { tournamentStatus: tournamentState_1.TournamentStatus.IN_PROGRESS, inProgressTournamentStatus: tournamentState_1.InProgressTournamentStatus.BETWEEN_ROUNDS, roundData: (0, tournamentState_2.getRoundData)(now, isFirstRound), leaderboard: (0, leaderboard_1.getLeaderboardPage)(numUsers, 0, false), success: true })); };
var getMultiChoiceAnswers = function (questionJson) { return questionJson.user_data.answers; };
var getCorrectCodeAnswers = function (questionJson) {
    var userData = questionJson.user_data;
    var answers = [userData.source_code1, userData.source_code2, userData.source_code3, userData.source_code4];
    return answers.filter(function (answer) { return answer !== undefined; });
};
var getAnswers = function (questionJson, questionType) {
    switch (questionType) {
        case tournamentState_1.QuestionTypes.MULTICHOICE:
        case tournamentState_1.QuestionTypes.BINARY_CHOICE:
        case tournamentState_1.QuestionTypes.QUAD_CHOICE:
        case tournamentState_1.QuestionTypes.SNIPPET_BINARY_CHOICE:
        case tournamentState_1.QuestionTypes.SINGLE_SELECT_REMEDIATION:
            return getMultiChoiceAnswers(questionJson);
        case tournamentState_1.QuestionTypes.CORRECT_CODE:
            return getCorrectCodeAnswers(questionJson);
        default:
            return null;
    }
};
var getQuestionData = function (now, isFirstRound, questionNumber, questionType) {
    var _a, _b, _c;
    var questionJson = questions_1.questionsByType[questionType];
    return {
        startsAt: new Date(now - 1000 * 60 * 1),
        endsAt: new Date(now + 1000 * 60 * 10),
        roundNumber: isFirstRound ? 1 : 2,
        questionNumber: questionNumber,
        framework: chance.pickone(frameworks_1.TOURNAMENT_FRAMEWORKS),
        questionId: chance.integer({ min: 1, max: 1000 }),
        questionType: questionType,
        answerType: tournamentState_1.AnswerTypes.SINGLE_ANSWER,
        availableAnswers: getAnswers(questionJson, questionType),
        questionTitle: (_a = questionJson.user_data) === null || _a === void 0 ? void 0 : _a.question,
        codeMirrorMode: questionJson.code_mirror_mode || null,
        sourceCode: ((_b = questionJson.user_data) === null || _b === void 0 ? void 0 : _b.source_code) || null,
        folderStructureCode: ((_c = questionJson === null || questionJson === void 0 ? void 0 : questionJson.user_data) === null || _c === void 0 ? void 0 : _c.folder_structure_code) || null,
    };
};
var getQuestionInProgressState = function (_a) {
    var now = _a.now, numUsers = _a.numUsers, isFirstRound = _a.isFirstRound, questionType = _a.questionType, didSubmitAnswer = _a.didSubmitAnswer, questionNumber = _a.questionNumber;
    var leaderboard = (0, leaderboard_1.getLeaderboardPage)(numUsers, 0, false);
    var roundAnswers = new Array(questionNumber).fill(false).map(function () { return chance.bool(); });
    roundAnswers[questionNumber - 1] = false;
    var type = questionType !== null && questionType !== void 0 ? questionType : chance.pickone(Object.values(tournamentState_1.QuestionTypes));
    return {
        tournamentStatus: tournamentState_1.TournamentStatus.IN_PROGRESS,
        inProgressTournamentStatus: tournamentState_1.InProgressTournamentStatus.QUESTION_IN_PROGRESS,
        roundData: (0, tournamentState_2.getRoundData)(now, isFirstRound),
        questionData: getQuestionData(now, isFirstRound, questionNumber, type),
        answerData: null,
        submittedAnswers: didSubmitAnswer ? [chance.integer({ min: 1, max: (0, questions_1.maxAnswersByType)(type) }).toString()] : null,
        roundAnswers: roundAnswers,
        leaderboard: leaderboard,
        userAnswersInfo: numUsers > 0
            ? {
                totalAnswered: numUsers / 2,
                user: { nickname: leaderboard.users[0].nickname, avatar: leaderboard.users[0].avatar },
            }
            : null,
        success: true,
    };
};
var getAnswerData = function (_a) {
    var now = _a.now, isFirstRound = _a.isFirstRound, questionNumber = _a.questionNumber, didSubmitAnswer = _a.didSubmitAnswer, didAnswerCorrectly = _a.didAnswerCorrectly, submittedAnswer = _a.submittedAnswer, questionType = _a.questionType;
    var maxAnswers = (0, questions_1.maxAnswersByType)(questionType);
    var correctAnswer = chance.integer({ min: 1, max: maxAnswers });
    if (didSubmitAnswer && submittedAnswer) {
        if (didAnswerCorrectly) {
            correctAnswer = submittedAnswer;
        }
        else {
            correctAnswer = submittedAnswer + 1;
            if (correctAnswer > maxAnswers)
                correctAnswer = 1;
        }
    }
    return {
        startsAt: new Date(now - 1000 * 60 * 1),
        endsAt: new Date(now + 1000 * 60 * 10),
        roundNumber: isFirstRound ? 1 : 2,
        questionNumber: questionNumber,
        framework: chance.pickone(frameworks_1.TOURNAMENT_FRAMEWORKS),
        questionId: chance.integer({ min: 1, max: 1000 }),
        answers: [correctAnswer.toString()],
        questionScore: didAnswerCorrectly ? chance.integer({ min: 500, max: 1000 }) : 0,
    };
};
var getAnswerRevealedState = function (_a) {
    var now = _a.now, numUsers = _a.numUsers, isFirstRound = _a.isFirstRound, questionType = _a.questionType, questionNumber = _a.questionNumber, didSubmitAnswer = _a.didSubmitAnswer, didAnswerCorrectly = _a.didAnswerCorrectly;
    var leaderboard = (0, leaderboard_1.getLeaderboardPage)(numUsers, 0, false);
    var numQuestion = questionNumber !== null && questionNumber !== void 0 ? questionNumber : chance.integer({ min: 1, max: 10 });
    var roundAnswers = new Array(numQuestion).fill(false).map(function () { return chance.bool(); });
    if (didAnswerCorrectly)
        roundAnswers[numQuestion - 1] = true;
    var type = questionType !== null && questionType !== void 0 ? questionType : chance.pickone(Object.values(tournamentState_1.QuestionTypes));
    var submittedAnswer = didSubmitAnswer ? chance.integer({ min: 1, max: (0, questions_1.maxAnswersByType)(type) }) : null;
    return {
        tournamentStatus: tournamentState_1.TournamentStatus.IN_PROGRESS,
        inProgressTournamentStatus: tournamentState_1.InProgressTournamentStatus.ANSWER_REVEALED,
        roundData: (0, tournamentState_2.getRoundData)(now, isFirstRound),
        questionData: getQuestionData(now, isFirstRound, numQuestion, type),
        answerData: getAnswerData({
            now: now,
            questionNumber: numQuestion,
            isFirstRound: isFirstRound,
            didSubmitAnswer: didSubmitAnswer,
            didAnswerCorrectly: didAnswerCorrectly,
            submittedAnswer: submittedAnswer,
            questionType: type,
        }),
        submittedAnswers: submittedAnswer ? [submittedAnswer.toString()] : null,
        roundAnswers: roundAnswers,
        leaderboard: leaderboard,
        userAnswersInfo: null,
        success: true,
    };
};
var getFinishedState = function (now, numUsers) { return (__assign(__assign({}, emptyState), { tournamentStatus: tournamentState_1.TournamentStatus.FINISHED, leaderboard: (0, leaderboard_1.getLeaderboardPage)(numUsers, 0, false, tournamentState_1.TournamentProgressStatus.PARTICIPATED) })); };
var getTournamentProgressState = function (_a) {
    var tournamentStatus = _a.tournamentStatus, inProgressTournamentStatus = _a.inProgressTournamentStatus, isFirstRound = _a.isFirstRound, leaderboardLimit = _a.leaderboardLimit, questionType = _a.questionType, didSubmitAnswer = _a.didSubmitAnswer, didAnswerCorrectly = _a.didAnswerCorrectly, questionNumber = _a.questionNumber;
    var numUsers = leaderboardLimit;
    var now = Date.now();
    var firstRound = isFirstRound !== null && isFirstRound !== void 0 ? isFirstRound : false;
    var numQuestion = questionNumber !== null && questionNumber !== void 0 ? questionNumber : chance.integer({ min: 1, max: 10 });
    var submittedAnswer = didSubmitAnswer !== null && didSubmitAnswer !== void 0 ? didSubmitAnswer : chance.bool();
    var answeredCorrectly = submittedAnswer ? didAnswerCorrectly !== null && didAnswerCorrectly !== void 0 ? didAnswerCorrectly : chance.bool() : false;
    switch (tournamentStatus) {
        case tournamentState_1.TournamentStatus.PENDING:
            return pendingState;
        case tournamentState_1.TournamentStatus.OPENED:
            return openedState;
        case tournamentState_1.TournamentStatus.IN_PROGRESS:
            if (inProgressTournamentStatus === tournamentState_1.InProgressTournamentStatus.NEXT_ROUND_SCHEDULED) {
                if (isFirstRound)
                    return getFirstRoundScheduledState(now);
                return getNextRoundScheduledState(now, numUsers);
            }
            if (inProgressTournamentStatus === tournamentState_1.InProgressTournamentStatus.BETWEEN_ROUNDS) {
                return getInBetweenRoundsState(now, numUsers, firstRound);
            }
            if (inProgressTournamentStatus === tournamentState_1.InProgressTournamentStatus.QUESTION_IN_PROGRESS) {
                return getQuestionInProgressState({
                    now: now,
                    numUsers: numUsers,
                    isFirstRound: firstRound,
                    questionType: questionType,
                    didSubmitAnswer: submittedAnswer,
                    questionNumber: numQuestion,
                });
            }
            if (inProgressTournamentStatus === tournamentState_1.InProgressTournamentStatus.ANSWER_REVEALED) {
                return getAnswerRevealedState({
                    now: now,
                    numUsers: numUsers,
                    isFirstRound: firstRound,
                    questionType: questionType,
                    didSubmitAnswer: submittedAnswer,
                    didAnswerCorrectly: answeredCorrectly,
                    questionNumber: numQuestion,
                });
            }
            return emptyState;
        case tournamentState_1.TournamentStatus.FINISHED:
            return getFinishedState(now, numUsers);
        default:
            return emptyState;
    }
};
exports.default = getTournamentProgressState;
